// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__n1dXt","name":"Header_name__3_dzi","birthday":"Header_birthday__ddo42","skeleton":"Header_skeleton__aRdFR"};